/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    get searchURL(): string{
      return `${this.dataCollectorService.baseurl()}/search/`;
    }
    public searchKeywordChanged: Subject<string> = new Subject<string>();
    public setSearchKeywordField: Subject<string> = new Subject<string>();
    public accessibleModules: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor(private dataCollectorService: DataCollectorService) {}

    getCount(keyword, moduleName): Observable<any>{
        const params ={
            'filter.keyword' : keyword,
            'module_name': moduleName,
        };
        const searchUrl = this.searchURL+'count';
        return this.dataCollectorService.getData(searchUrl,params);
    }

    getSearchKeyValue(searchKey): any{
        if(typeof(searchKey) === 'object' && Object.keys(searchKey)?.length === 0){
          searchKey = JSON.stringify(searchKey);
        }else if(searchKey === '{}'){
          searchKey = JSON.stringify(JSON.parse(searchKey));
        }
        return searchKey;
      }
}
